import React, { useMemo, useState } from "react";
import Slider from "react-slick";
import { useStaticQuery, graphql } from "gatsby";

// Components //
import TitleSection from "../../molecules/title-section";
import MediaCard from "../../molecules/media-card/mediaCard";
import Button from "../../atoms/button/button";
import { Link } from "gatsby";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Styles //
import "./new-tendencies-section.scss";


const NewTendenciesSection = (props: ReferenciaContenido) => {

    const data = useStaticQuery(graphql`
    query NEWTENDENCIESDATA {
        dataSub: contentfulSubcategorias(contentful_id: {eq: "2SmuRXdJp2FuOoTdiVoL5D"}) {
            referenciaSubcategorias {
                slug
                referenciaInterna {
                    referenciaContenido {
                        contentful_id
                    }
                    referenciaCabecera {
                        migaDePan
                        referenciaMultimedia {
                            audioUrl
                            autor
                            categoriaMultimedia
                            contentful_id
                            createdAt
                            descripcion {
                                raw
                            }
                                imagenPrincipal {
                                    gatsbyImageData(
                                        layout: CONSTRAINED
                                        outputPixelDensities: [0.5, 1, 2]
                                        breakpoints: [320, 768, 1024, 1440]
                                        placeholder: BLURRED
                                        sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                                    )
                                    description                                    
                                }
                            nuevoContenido
                            tematica
                            textoIntroductorio
                            tiempoLectura
                            tituloBoton
                            tituloMultimedia
                            videoUrl
                            video {
                                file {
                                    url
                                    fileName
                                    contentType
                                }
                            }
                        }
                    }
                }
            }
        }
    }         
    `);

    const getThemes = (sub) => {
        let themeListAux: any[] = ["Todas"];
        sub.map( (obj) => {
            themeListAux.push(obj.referenciaInterna.referenciaCabecera.referenciaMultimedia.tematica);
        })
        themeListAux = themeListAux.filter(function(elem, index, self) {
            return index === self.indexOf(elem);
        })
        return themeListAux;
    }

    const transformData = (arr) => {
        return arr.map((sub) => { 
            return { 
                ...sub.referenciaInterna.referenciaCabecera.referenciaMultimedia,
                slug: sub.slug,
                parentContentfulId: sub.referenciaInterna.referenciaContenido[0].contentful_id
            }
        })
    }

    const tabTitles = useMemo(() => getThemes(data.dataSub.referenciaSubcategorias), [])
    const transformedData = useMemo(() => transformData(data.dataSub.referenciaSubcategorias), [])

    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState(0);
    const [active, setActive] = useState(0);

    const handleTabs = (e) => {
        const index = parseInt(e.target.id, 0);
        if (index !== active) {
            setActive(index);
        }
    };

    const CarouselGeneral = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        arrows: false,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        variableWidth: true,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
        },
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    variableWidth: false,
                },
            },
        ],
    };

    const goToNext = () => {
        if (sliderIndex < slider.props.children[0].length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const isActiveBack = () => sliderIndex > 0;
    const isActiveNext = () => sliderIndex < slider?.props.children[0].length - 1;

    const getLastTrend = (array) => {return array.map(obj => { return { ...obj, date: new Date(obj.createdAt) } }).sort((a:any, b: any) => b.date - a.date)};

    return (
        <div className="o-tendencies-section">
            <div className="container">
                <TitleSection title={props.tituloGeneral}/>
                <div className="tabs">
                    <div className="arrows-slider">
                        <span className={`arrow icon-chevron-left ${ isActiveBack() ? "active" : "" }`} onClick={goToBack}></span>
                        <Slider ref={(c) => { setSlider(c); }} {...CarouselGeneral}>
                            {tabTitles.map((item, i) => (
                                <button onClick={handleTabs} className={`tabs__tab ${active === i ? "active" : ""}`} id={String(i)}>
                                    {item}
                                </button>
                            ))}
                        </Slider>
                        <span className={`arrow  icon-chevron-right  ${ isActiveNext() ? "active" : "" }`} onClick={goToNext}></span>
                    </div>
                </div>
                {tabTitles && tabTitles.length > 0 ? (
                    <>
                        {tabTitles.map((subCat, i) => (
                            <div className={`tabs-panel ${active === i ? "active" : ""}`}>
                                {
                                    <div className={`o-tendencies-section__container`}>    
                                        {active === i && 
                                            <>
                                                {getLastTrend(transformedData).filter(item => item.tematica === subCat).slice(0,3).map((item) => (
                                                        <div className="itemTematica">
                                                            <MediaCard 
                                                            tituloMultimedia={item.tituloMultimedia}
                                                            descripcion={item.descripcion}
                                                            imagenPrincipal={item.imagenPrincipal}
                                                            tituloBoton={item.tituloBoton}
                                                            tematica={item.tematica}
                                                            categoriaMultimedia={item.categoriaMultimedia}
                                                            nuevoContenido={item.nuevoContenido}
                                                            textoIntroductorio={item.textoIntroductorio}
                                                            slug={`./biblioteca/${item.slug}`}
                                                            parentContentfulId={item.parentContentfulId}
                                                            createdAt={item.createdAt}
                                                        />
                                                        </div>
                                                ))}
                                                {getLastTrend(transformedData).slice(0,3).map((item, i) => (
                                                    subCat != item.tematica && subCat == "Todas" &&
                                                        <div className="itemTematica">
                                                            <MediaCard 
                                                            tituloMultimedia={item.tituloMultimedia}
                                                            descripcion={item.descripcion}
                                                            imagenPrincipal={item.imagenPrincipal}
                                                            tituloBoton={item.tituloBoton}
                                                            tematica={item.tematica}
                                                            categoriaMultimedia={item.categoriaMultimedia}
                                                            nuevoContenido={item.nuevoContenido}
                                                            textoIntroductorio={item.textoIntroductorio}
                                                            slug={`./biblioteca/${item.slug}`}
                                                            parentContentfulId={item.parentContentfulId}
                                                            createdAt={item.createdAt}
                                                            />
                                                        </div>
                                                ))}
                                            </>}
                                    </div>
                                }
                            </div>
                        ))}  
                    </>
                ) : (
                    <>
                        <div className={`o-tendencies-section__container`}>
                            <div className="arrows-slider">
                                <span className={`arrow icon-chevron-left ${ isActiveBack() ? "active" : "" }`} onClick={goToBack}></span>
                                <span className={`arrow  icon-chevron-right  ${ isActiveNext() ? "active" : "" }`} onClick={goToNext}></span>
                            </div>
                            <Slider ref={(c) => { setSlider(c); }} {...CarouselGeneral}>
                                {transformedData.map((item, i) => (
                                    <MediaCard
                                        tituloMultimedia={item.tituloMultimedia}
                                        descripcion={item.descripcion}
                                        imagenPrincipal={item.imagenPrincipal}
                                        tituloBoton={item.tituloBoton}
                                        tematica={item.tematica}
                                        categoriaMultimedia={item.categoriaMultimedia}
                                        nuevoContenido={item.nuevoContenido}
                                        textoIntroductorio={item.textoIntroductorio}
                                        slug={`./biblioteca/${item.slug}`}
                                    />
                                ))}
                            </Slider>
                        </div>
                    </>
                )}       
            </div>
            <div className="o-tendencies-section__buttons">
                <Link to={props.redireccionBoton}>
                    <Button
                        type="link"
                        text={props.tituloBoton}
                        classname={`a-button__magenta`}
                        isDisabled={false}
                        href={void(0)}
                    />
                </Link>
            </div>
        </div>
        
    );
};

export default NewTendenciesSection;
